module.exports = __webpack_public_path__ + "static/media/accept-icon.099b6d9a.svg";